module.exports = __webpack_public_path__ + "img/BG-3.92842b94.png";